<h2 mat-dialog-title>{{ title() }}</h2>

<mat-dialog-content>
	<!-- Error State -->
	@if (error()) {
		<div class="alert alert-danger mb-3" role="alert">
			<i class="fas fa-exclamation-triangle"></i> {{ error() }}
		</div>
	}

	<form [formGroup]="rateForm">
		<div class="form-row">
			<mat-form-field appearance="fill" class="w-100 mb-3">
				<mat-label>Data od</mat-label>
				<input [matDatepicker]="dateFrom" formControlName="dateFrom" matInput required />
				<mat-hint>DD.MM.YYYY</mat-hint>
				<mat-datepicker-toggle [for]="dateFrom" matIconSuffix></mat-datepicker-toggle>
				<mat-datepicker #dateFrom></mat-datepicker>
				@if (rateForm.get('dateFrom')?.hasError('required')) {
					<mat-error>Data od jest wymagana</mat-error>
				}
			</mat-form-field>
		</div>

		<div class="form-row">
			<mat-form-field appearance="fill" class="w-100 mb-3">
				<mat-label>Data do</mat-label>
				<input [matDatepicker]="dateTo" formControlName="dateTo" matInput />
				<mat-hint>DD.MM.YYYY</mat-hint>
				<mat-datepicker-toggle [for]="dateTo" matIconSuffix></mat-datepicker-toggle>
				<mat-datepicker #dateTo></mat-datepicker>
				@if (rateForm.hasError('dateRange') && rateForm.get('dateTo')?.value) {
					<mat-error>Data końcowa nie może być wcześniejsza niż data początkowa</mat-error>
				}
			</mat-form-field>
		</div>

		<div class="form-row">
			<mat-form-field appearance="fill" class="w-100 mb-3">
				<mat-label>Stawka (PLN)</mat-label>
				<input formControlName="rate" matInput required type="number" />
				@if (rateForm.get('rate')?.hasError('required')) {
					<mat-error>Stawka jest wymagana</mat-error>
				}
				@if (rateForm.get('rate')?.hasError('min')) {
					<mat-error>Stawka musi być większa lub równa 0</mat-error>
				}
			</mat-form-field>
		</div>

		<div class="form-row">
			<mat-form-field appearance="fill" class="w-100 mb-3">
				<mat-label>Uwagi</mat-label>
				<textarea formControlName="comments" matInput rows="3"></textarea>
			</mat-form-field>
		</div>
	</form>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button (click)="onCancel()" [disabled]="isSaving()" mat-raised-button>Anuluj</button>
	<button (click)="onSave()" [disabled]="!rateForm.valid || isSaving()" color="primary" mat-raised-button>
		@if (isSaving()) {
			<mat-spinner diameter="20" style="display: inline-block; margin-right: 8px"></mat-spinner>
		}
		{{ isSaving() ? 'Zapisywanie...' : 'Zapisz' }}
	</button>
</mat-dialog-actions>
